import React from "react";
import { motion } from "framer-motion";
import HeroHexagon from "../HeroHexagon";

const RefundPolicy = () => {
  const textAnimate = {
    hidden: { opacity: 0, y: -100 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        ease: "easeInOut",
        duration: 0.8,
      },
    },
  };
  return (
    <>
      <div className="hero is-flex is-center dir-column ">
        <div className="container">
          <div className="hero-content clr-white">
            <motion.div
              className="content"
              initial="hidden"
              whileInView={"visible"}
              viewport={{ once: false, amount: 0.1 }}
              transition={{ staggerChildren: 1 }}
            >
              <motion.h5 className="fw-600 " variants={textAnimate}>
                <span className="line-shape pb-12 line-shape_left">
                  Legal
                </span>
              </motion.h5>

              <motion.h1 className="my-32 fs-h3" variants={textAnimate}>
                Refund <span className="italic">Policy</span>
              </motion.h1>
              <motion.p className="fw-400" variants={textAnimate}>
                Last updated: March 2026
              </motion.p>
            </motion.div>
            <HeroHexagon />
          </div>
        </div>
      </div>
      <section className="about">
        <div className="container">
          <div className="about-content">
            <h5 className="clr-secondary mb-16">1. Service Model</h5>
            <p className="mb-32">
              9Feathers provides custom software development services on a contract basis. We do not sell products, subscriptions, or accept automated payments through this website. All payments are made manually by clients based on contractual terms.
            </p>

            <h5 className="clr-secondary mb-16">2. Payment Terms</h5>
            <p className="mb-32">
              Payments are invoiced based on milestones defined in the signed service agreement between 9Feathers and the client. Payment schedules, amounts, and methods are agreed upon before any work begins.
            </p>

            <h5 className="clr-secondary mb-16">3. Refund Eligibility</h5>
            <p className="mb-16">Due to the custom nature of software development services:</p>
            <ul className="mb-32">
              <li><strong>Before work begins:</strong> If a project has not yet commenced, any advance payment is fully refundable upon written request.</li>
              <li><strong>After work has started:</strong> Payments for completed milestones are non-refundable, as the work has already been delivered. Payments for incomplete milestones may be partially refundable based on the work completed to date.</li>
            </ul>

            <h5 className="clr-secondary mb-16">4. Dispute Resolution</h5>
            <p className="mb-32">
              If you are not satisfied with a deliverable, we encourage you to contact us so we can address your concerns. We are committed to working with clients to resolve issues before they reach the point of a refund request. Disputes are handled per the terms of the individual service agreement.
            </p>

            <h5 className="clr-secondary mb-16">5. How to Request a Refund</h5>
            <p>
              To request a refund, please contact us in writing at{" "}
              <a href="mailto:info@9feathers.app" className="clr-primary">info@9feathers.app</a>{" "}
              with your project details and reason for the request. We will respond within 5 business days.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default RefundPolicy;
